export default __webpack_public_path__ + "static/media/Pretendard-SemiBold.7e5eaaf6.woff2";